var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCash = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 25,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M23.188 18.834H3.173a.811.811 0 0 1-.812-.811v-9.35c0-.448.364-.811.812-.811h20.015c.448 0 .811.363.811.811v9.35a.811.811 0 0 1-.811.81Z",
  fill: "url(#a)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m2.383 17.685 1.149 1.149h19.656a.811.811 0 0 0 .811-.811v-9.35a.811.811 0 0 0-.811-.811H3.173a.811.811 0 0 0-.812.811v8.965l.022.047Z",
  fill: "url(#b)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.971 17.617H1.956a.811.811 0 0 1-.811-.812v-9.35c0-.447.363-.81.81-.81h20.016c.448 0 .811.363.811.81v9.35a.811.811 0 0 1-.81.812Z",
  fill: "url(#c)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "m1.167 16.468 1.148 1.149h19.656a.811.811 0 0 0 .811-.812v-9.35a.811.811 0 0 0-.81-.81H1.955a.811.811 0 0 0-.811.81v8.966l.022.047Z",
  fill: "url(#d)"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M20.827 16.472H.81A.811.811 0 0 1 0 15.661V6.31C0 5.863.363 5.5.811 5.5h20.016c.448 0 .811.363.811.811v9.35a.811.811 0 0 1-.811.811Z",
  fill: "url(#e)"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M20.417 7.82a1.169 1.169 0 0 1-1.098-1.099c-.006-.13.009-.255.042-.373H2.279c.033.118.048.243.042.373A1.169 1.169 0 0 1 1.223 7.82c-.2.01-.39-.03-.559-.11v6.553c.168-.08.359-.121.56-.11.587.03 1.066.511 1.097 1.098a1.16 1.16 0 0 1-.042.373H19.36a1.162 1.162 0 0 1-.04-.373c.03-.587.51-1.068 1.096-1.099.201-.01.392.03.56.11V7.71c-.168.08-.359.121-.56.11Z",
  fill: "url(#f)"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M18.995 13.35H14.68v1.242h4.315V13.35ZM10.82 13.795a2.81 2.81 0 1 0 0-5.62 2.81 2.81 0 0 0 0 5.62ZM6.958 7.38H2.643V8.62h4.315V7.38Z",
  fill: "#fff"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 2.361,
  y1: 13.348,
  x2: 23.999,
  y2: 13.348,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#61DB99"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009E74"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 14.023,
  y1: 17.154,
  x2: 13.275,
  y2: 13.57,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#009E74",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009E74"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: 1.144,
  y1: 12.131,
  x2: 22.782,
  y2: 12.131,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#61DB99"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009E74"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d",
  x1: 13.591,
  y1: 18.335,
  x2: 10.112,
  y2: 4.557,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#005841",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009E74"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "e",
  x1: 0,
  y1: 10.986,
  x2: 21.637,
  y2: 10.986,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A7F3CE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#61DB99"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "f",
  x1: 5.168,
  y1: 5.335,
  x2: 18.936,
  y2: 19.103,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#61DB99"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009E74"
})))));
export default SvgCash;